import React from 'react';
import { I18n } from 'common/i18n';
import './FormulaEditor.scss';

const t = (key: string) => I18n.translate(key, { scope: 'shared.components.formula_editor' });

export interface ValidationElementsProps {
  formulaValid: boolean | null;
}

export const ValidationElements: React.FC<ValidationElementsProps> = ({ formulaValid }) => {
  if (formulaValid === true) {
    return (
      <div
        className="forge-typography--label1 validation-success"
        data-testid="formula-editor-validation-success"
      >
        {t('formula_good')}
      </div>
    );
  } else if (formulaValid === false) {
    return (
      <div
        className="forge-typography--label1 validation-error"
        data-testid="formula-editor-validation-failure"
      >
        {t('formula_bad')}
      </div>
    );
  } else {
    return <div className="validation-placeholder" data-testid="formula-editor-validation-placeholder" />;
  }
};
